<template>
  <div class="progress-bar-wrapper">
    <span class="progress-bar">
      <span class="progress-bar__fill" :style="progressBarStyles"></span>
    </span>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Timer from './../core/Timer';

export default {
  data() {
    return {
      timer: {
        interval: 15000,
        pollRate: 16,
        instance: null,
        startTime: null
      },
      progressBar: {
        progress: 0
      }
    }
  },

  computed: {
    progressBarStyles: function() {
      return {
        transform: `translate3d(-${100 - this.progressBar.progress}%, 0, 0)`
      };
    }
  },

  methods: {
    ...mapActions([
      'fetchServers',
      'fetchDataCenters'
    ]),
    async initServerData() {
      await this.fetchDataCenters();
      await this.fetchServers();

      this.initTimer();
      this.timer.instance.startTimer();
    },
    updateServers() {
      this.fetchDataCenters();
      this.fetchServers();
    },
    initTimer() {
      this.timer.instance = new Timer();
      this.timer.instance.listen(this.updateProgress);
      this.timer.instance.setInterval(this.timer.pollRate);
    },
    updateProgress() {
      if (this.timer.startTime === null) {
        this.timer.startTime = Date.now();
      }

      let elapsed = Date.now() - this.timer.startTime;
      this.progressBar.progress = (elapsed / this.timer.interval) * 100;

      // We want to stop the timer and restart it to clear up any hanging timers.
      // Also, add the poll rate to the timer so that we have a buffer starting it.
      if (elapsed >= this.timer.interval) {
        this.timer.instance.stopTimer();
        this.updateServers();
        this.timer.startTime = Date.now() - this.timer.pollRate;
        this.timer.instance.startTimer();
      }
    }
  },

  created() {
    this.initServerData();
  }
}
</script>

<style lang="scss" type="text/scss" scoped>
.progress-bar-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
}

.progress-bar {
  position: relative;
  width: 100%;
  height: em(4px);
  overflow: hidden;
}

.progress-bar__fill {
  position: absolute;
  z-index: 3;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.9);
  will-change: transform;
}
</style>